var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hp-page-title"},[(_vm.title)?_c('h1',{staticClass:"mb-8"},[_vm._v(_vm._s(_vm.title))]):_c('h1',{staticClass:"mb-8"},[_vm._v(_vm._s(_vm.pageTitle))]),(_vm.desc)?_c('p',{staticClass:"mb-0 hp-p1-body"},[_vm._v(_vm._s(_vm.desc))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }